<div class="tw:p-4 admin-page" data-test="bulk-off-dialog">
  <h2 class="admin-h2">Turn off {{count}} feature{{count === 1 ? '' : 's'}}?</h2>

  <p>
    Turning off {{data.scope}}. These go off for everyone using Tuition Management within about 30 seconds.
    Nothing is turned on, and each change is recorded in its history.
  </p>

  <ul class="tw:my-3 tw:max-h-80 tw:overflow-y-auto" data-test="bulk-off-list">
    @for (item of toTurnOff; track item.switchKey) {
      <li class="tw:py-1" data-test="bulk-off-item">
        <strong>{{item.displayName}}</strong>
        <span class="tw:text-sm tw:opacity-75">
          @if (item.introducedOn) { · introduced {{item.introducedOn | date:'dd/MM/yyyy'}} }
          @if (item.parentKey) { · option of {{item.parentKey}} }
        </span>
        <div class="tw:text-xs tw:opacity-50">{{item.switchKey}}</div>
      </li>
    }
  </ul>

  @if (skipped.length > 0) {
    <p class="tw:mb-1">Left on:</p>
    <ul class="tw:my-1 tw:max-h-40 tw:overflow-y-auto" data-test="bulk-off-skipped">
      @for (item of skipped; track item.switchKey) {
        <li class="tw:py-1" data-test="bulk-off-skipped-item">
          <strong>{{item.displayName}}</strong>
          <span class="tw:text-sm tw:opacity-75" data-test="bulk-off-skipped-reason"> · {{item.skippedReason}}</span>
          <div class="tw:text-xs tw:opacity-50">{{item.switchKey}}</div>
        </li>
      }
    </ul>
  }

  <div class="tw:flex tw:justify-end tw:gap-2">
    <button type="button" class="btn" (click)="cancel()" data-test="bulk-off-cancel">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="confirm()" data-test="bulk-off-confirm">Turn off {{count}}</button>
  </div>
</div>
